var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLowerAngleBracket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00005 6.9499C5.86672 6.9499 5.74172 6.92907 5.62505 6.8874C5.50838 6.84574 5.40005 6.7749 5.30005 6.6749L0.700049 2.0749C0.516715 1.89157 0.425049 1.65824 0.425049 1.3749C0.425049 1.09157 0.516715 0.858236 0.700049 0.674902C0.883382 0.491569 1.11672 0.399902 1.40005 0.399902C1.68338 0.399902 1.91672 0.491569 2.10005 0.674902L6.00005 4.5749L9.90005 0.674902C10.0834 0.491569 10.3167 0.399902 10.6 0.399902C10.8834 0.399902 11.1167 0.491569 11.3 0.674902C11.4834 0.858236 11.575 1.09157 11.575 1.3749C11.575 1.65824 11.4834 1.89157 11.3 2.0749L6.70005 6.6749C6.60005 6.7749 6.49172 6.84574 6.37505 6.8874C6.25838 6.92907 6.13338 6.9499 6.00005 6.9499Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerAngleBracket);
export default __webpack_public_path__ + "static/media/lower-angle-bracket.d1fe16c0dcc7cc249bfd5970290bdae5.svg";
export { ForwardRef as ReactComponent };